import axios from 'axios'
import auth from './auth'
import ElementUI from 'element-ui'

const service = axios.create({
  baseURL: config.baseURL // api的base_url
})

// 请求拦截器
service.interceptors.request.use(request => {
  // 如果存在token,附加到到请求头
  auth.appendToken(request.headers)
  return request
}, error => {
  ElementUI.Message.error(error.message)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(response => {
  // 如果存在token,提取到本地localStorage
  if (response.status === 200) {
    auth.pickToken(response.headers)
  }
  return response
}, error => {
  ElementUI.Message.error(error.message)
  if (error.response && error.response.status === 401) {
    auth.clearToken();
    location.href = '/'
  }
})

export default service
